import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-visualizza-dettaglio',
  templateUrl: './visualizza-dettaglio.component.html',
  styleUrls: ['./visualizza-dettaglio.component.css']
})
export class VisualizzaDettaglioComponent implements OnInit {
  objdettaglio: any;
  idutente: any;
  titolo: string = '';
  lstElencoNominativi: any;
  obj: any;
  idRichiesta: any;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<VisualizzaDettaglioComponent>,
    private snackBar: MatSnackBar,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettagli Richiesta Adesione'
  }


  ngOnInit(): void {
  /*  if (this.data.idRichiesta) { }
    if (this.data.idutente) {
      console.log('idutente', this.data.idutente);
    }
    if (this.data.row >= 0) { console.log('row', this.data.row); }*/

  //  console.log('idrichiesta', this.data.row.idRichiesta);
  //  console.log('idutente', this.data.idutente);
  //  console.log('row',this.data.row);

    if (this.data.idRichiesta) { }
    if (this.data.idutente) { }
    if (this.data.row) { }

    console.log('idrichiesta', this.data.row.idRichiesta )
    this.getProfiloUtente();
   this.getListaNominativi();


    this.getDettaglio();
    
  }

  getDettaglio() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.data.row.idRichiesta).subscribe((res: any) => {
      this.obj = res
      // console.log(res, 'res')
    })
  }


  getProfiloUtente() {
    this.srvUtilita.getObj('Utenti/GetUtentiDettaglio?idUtentiProfilo=' + this.data.idutente).subscribe((res: any) => {
      this.objdettaglio = res
    // console.log(res, 'res')
    })
  }

  getListaNominativi() {
    this.srvUtilita.getLista('Utenti/GetElencoNominativi?iIdRichiesta=' + this.data.row.idRichiesta).subscribe((res: any) => {
      this.lstElencoNominativi = res
     // console.log(res, 'res')
    })
  }

  btnAnnulla() {
    this.dialogRef.close()
  }

}
